import React from 'react';

interface TableSkeletonProps {
  /** Number of rows to show */
  rows?: number;
  /** Number of columns to show */
  cols?: number;
  /** Custom className */
  className?: string;
}

/**
 * Skeleton component for table rows
 * Used in list/table pages (Clients, Leads, Tasks, Orders, etc.)
 */
export const TableSkeleton: React.FC<TableSkeletonProps> = ({
  rows = 6,
  cols = 5,
  className = '',
}) => {
  return (
    <div className={`animate-pulse space-y-3 ${className}`}>
      {[...Array(rows)].map((_, i) => (
        <div key={i} className="flex items-center gap-4 py-3 border-b border-gray-100">
          {[...Array(cols)].map((_, j) => (
            <div
              key={j}
              className="h-4 rounded-lg bg-gray-100 flex-1"
              style={{
                width: j === 0 ? '20%' : j === cols - 1 ? '15%' : 'auto',
              }}
            />
          ))}
        </div>
      ))}
    </div>
  );
};

